import { createContext, type Provider, useContext } from 'react';
import type { ConditionalFormattingModification } from 'owa-conditional-formatting';

export interface MailListItemContainerContextProps {
    conditionalFormattingModifications: ConditionalFormattingModification[];
}
const MailListItemContainerContext = createContext<MailListItemContainerContextProps>({
    conditionalFormattingModifications: [],
});

export const MailListItemContainerContextProvider: Provider<MailListItemContainerContextProps> =
    MailListItemContainerContext.Provider;

export default function useMailListItemContainerContext(): MailListItemContainerContextProps {
    return useContext(MailListItemContainerContext);
}
